<template>
  <div class="col-3">
    <p>
      Für die Große Kreisstadt Dachau ist ein engagierter und zielführender Dialog mit allen interessierten Bürgerinnen und Bürgern sehr wichtig. Vor diesem Hintergrund hat die Stadt das nachfolgende Online-Beteiligungsmodul entwickelt, mit dem Bürgerinnen und Bürgern seit dem 23.10.2018 eigene Anregungen, Wünsche, Vorschläge, Ideen – aber auch Kritikpunkte – direkt in die interaktive Karte bis zum 24.01.2019 eintragen konnten. Die 1. Etappe im Leitbildprozess ist nun erreicht. Wir – die Projektverantwortlichen - sind begeistert von den vielen und umfangreichen Eintragungen von Ihnen. Unter der Rubrik
      <router-link :to="{name: 'auswertung'}">{{'Auswertung '}}</router-link>können Sie die Ergebnisse übersichtlich nach Stadtteilen betrachten und unter der Rubrik
      <router-link to="/aktuelles">{{'Aktuelles '}}</router-link>finden Sie die aktuelle Pressemappe zu den weiteren Ergebnissen der Beteilgungsformate in Etappe 1. Die entsprechenden Informationen entnehmen Sie bitte der Presse und dem Internet. Wir halten Sie auf dem Laufenden - Denken Sie Dachau mit uns weiter!
    </p>
    <Karte />
    <hr />
  </div>
</template>

<script>
import Karte from "@/components/MachMit/Karte.vue";
import Timeline from "@/components/Timeline.vue";

export default {
  components: {
    Karte,
    Timeline
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$store.state.user) {
      this.$router.push("/machmit/karte/user/" + this.$store.state.user);
    }
  },
  methods: {
    showForm() {}
  }
};
</script>
<style scoped lang="scss">
</style>